import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {DeviationDefinition} from '../../../domain/deviation-definition';
import {PopupService} from '../../../component/popup.service';
import {CoreConfigurationService} from '../../../core-configuration.service';
import {DeviationDefinitionEditComponent} from '../deviation-definition-edit/deviation-definition-edit.component';

@Component({
    selector: 'app-deviation-definition-list',
    templateUrl: './deviation-definition-list.component.html',
    styleUrls: ['./deviation-definition-list.component.css'],
    standalone: false
})
export class DeviationDefinitionListComponent implements OnInit {
  definitions: DeviationDefinition[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private popupService: PopupService,
    public coreConfiguration: CoreConfigurationService) {
  }

  ngOnInit() {
    this.initValue();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.initValue();
      });
  }

  private initValue() {
    this.definitions = this.route.snapshot.data['data'].Definitions;
  }

  newDefinition() {
    this.editDefinition(new DeviationDefinition());
  }

  editDefinition(definition: DeviationDefinition) {
    this.popupService.openFromComponent(DeviationDefinitionEditComponent, {definition: definition})
      .subscribe(() =>{
        this.router.navigate(['admin', 'deviation', 'definitions'])
      })
  }
}
